import React from "react";

const SvgRefresh = props => (
  <svg viewBox="0 0 207 208" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Obecn\xE9 ikony">
        <path data-name="&lt;\u0158ez&gt;" fill="none" d="M0 0h207v208H0z" />
        <path d="M24.66 50.73L32 8.55c.67-3.88 3.08-4.81 5.39-2.08l39 46.18c2.32 2.73 1 5-3 5l-42.8.12a5.78 5.78 0 01-5.93-7.04zM185.48 155.58l-7.27 42.18c-.67 3.89-3.09 4.82-5.41 2.08l-39-46.17c-2.3-2.74-1-5 2.95-5l42.81-.12a5.78 5.78 0 015.92 7.03z" />
        <path d="M104.38 197.11a93.73 93.73 0 01-93.62-93.62 5 5 0 0110 0 83.61 83.61 0 00140.54 61.25 5 5 0 016.81 7.33 93.34 93.34 0 01-63.73 25.04zM193 108.49a5 5 0 01-5-5A83.61 83.61 0 0047.11 42.57a5 5 0 11-6.85-7.28A93.61 93.61 0 01198 103.49a5 5 0 01-5 5z" />
      </g>
    </g>
  </svg>
);

export default SvgRefresh;
